import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon'; // Import ListItemIcon
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';

// Import icons
import IconHome from '../assets/images/icon-home.svg';
import IconProblem from '../assets/images/icon-problem.svg';
import IconSolution from '../assets/images/icon-solution.svg';
import IconFeatures from '../assets/images/icon-features.svg';
import IconTech from '../assets/images/icon-tech.svg';
import IconGallery from '../assets/images/icon-gallery.svg';
import IconChallenges from '../assets/images/icon-challenges.svg';
import IconAbout from '../assets/images/icon-about.svg';


const navLinks = [
  { text: 'Home', path: '/', icon: IconHome },
  { text: 'Problem', path: '/problem', icon: IconProblem },
  { text: 'Solution', path: '/solution', icon: IconSolution },
  { text: 'Features', path: '/features', icon: IconFeatures },
  { text: 'Tech Deep Dive', path: '/tech', icon: IconTech },
  { text: 'Gallery', path: '/gallery', icon: IconGallery },
  { text: 'Challenges & Next Steps', path: '/challenges', icon: IconChallenges },
  { text: 'About Us', path: '/about', icon: IconAbout },
];

// Define styles for icons to control color if needed via CSS filter or directly if SVGs support it
const iconStyle = {
    filter: 'invert(20%) sepia(51%) saturate(5000%) hue-rotate(280deg) brightness(95%) contrast(90%)', // Example: Dark purple color
    width: '20px', // Adjust icon size
    height: '20px',
};


const SideDrawer = ({ open, onClose }) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderTopLeftRadius: 16, // Smoother border radius
        borderBottomLeftRadius: 16, // Smoother border radius
        borderTopRightRadius: 0, // Keep right side square as it docks
        borderBottomRightRadius: 0,
      }
    }}
    >
    {/* Use a light soft pink background, adjust width, add padding */}
    <List sx={{
        width: 230, // Slightly narrower width
        background: '#F8E8EE', // Light soft pink background
        height: '100%',
        paddingTop: '20px', // Add some padding at the top
         }}>
      {navLinks.map((item) => (
        <ListItem key={item.text} disablePadding>
          <ListItemButton component={Link} to={item.path} onClick={onClose} sx={{ paddingLeft: '24px', paddingRight: '24px' }}>
             {/* Add ListItemIcon */}
            <ListItemIcon sx={{ minWidth: '40px' }}>
                 {/* Use img tag for SVG icons */}
                <img src={item.icon} alt={`${item.text} icon`} style={iconStyle} />
            </ListItemIcon>
            {/* Use a darker color for text for better contrast, adjust font */}
            <ListItemText
                primary={item.text}
                sx={{
                    color: '#3a0ca3', // Darker color for contrast
                    '& .MuiListItemText-primary': { // Target the primary text style
                        fontWeight: 500, // Slightly bolder or adjust as needed
                        fontSize: '0.95rem', // Slightly smaller font size
                    }
                 }}
                 />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  </Drawer>
);

export default SideDrawer;
